import {
  PRIVACY_POLICY_ACTION_START,
  PRIVACY_POLICY_ACTION_ERROR,
  GET_ALL_PRIVACY_POLICIES,
  GET_PRIVACY_POLICY,
  CREATE_PRIVACY_POLICY,
  EXPIRE_PRIVACY_POLICY,
  ACTIVATE_PRIVACY_POLICY,
} from './actions';

const initialState = {
  loading: false,
  error: null,
  privacyPolicies: [],
  activePrivacyPolicy: null,
};

const privacyPolicyReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case PRIVACY_POLICY_ACTION_START:
      return { ...state, loading: true, error: null };
    case PRIVACY_POLICY_ACTION_ERROR:
      return { ...state, loading: false, error: action.payload };
    case GET_ALL_PRIVACY_POLICIES:
      return { ...state, loading: false, privacyPolicies: action.payload };
    case GET_PRIVACY_POLICY:
      return { ...state, loading: false, activePrivacyPolicy: action.payload };
    case CREATE_PRIVACY_POLICY:
      return { ...state, loading: false, privacyPolicies: [...state.privacyPolicies, action.payload] };
    case EXPIRE_PRIVACY_POLICY:
      return {
        ...state,
        loading: false,
        privacyPolicies: state.privacyPolicies.map((p: any) => (p.id === action.payload ? { ...p, is_expired: true } : p)),
      };
    case ACTIVATE_PRIVACY_POLICY:
      return {
        ...state,
        loading: false,
        privacyPolicies: state.privacyPolicies.map((p: any) => (p.id === action.payload ? { ...p, is_active: true } : p)),
      };
    default:
      return state;
  }
};

export default privacyPolicyReducer;

